import { render, staticRenderFns } from "./PopupAddMedicine.vue?vue&type=template&id=63a91961&"
import script from "./PopupAddMedicine.vue?vue&type=script&lang=ts&"
export * from "./PopupAddMedicine.vue?vue&type=script&lang=ts&"
import style0 from "./PopupAddMedicine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports